import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "page-manage" }
const _hoisted_2 = { class: "search-area" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  style: {textAlign: 'center'}
}
const _hoisted_7 = { class: "pagination-area" }
const _hoisted_8 = { class: "count" }

import {ref, onMounted } from "vue";
import { useRouter } from "vue-router";

import CommonError from '@/components/CommonError.vue';
import CommonLoader from '@/components/CommonLoader.vue';
import StatusTag from '@/components/StatusTag.vue';
import { getTagColor } from "@/utils";
import { getCustomerList } from '@/api'
import { Customer } from '@/types/Customer';
import { getTaxInfoTypeValue } from "@/utils/getValueForKey";
import { ElMessageBox } from 'element-plus';
import type { TableColumnCtx, TableInstance } from 'element-plus';




export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerManage',
  setup(__props) {

const loading = ref<boolean>(false);
const isError = ref<boolean>(false);

const data = ref<Customer[]>([])
const totalCount = ref<number>(0);
const currentPage = ref<number>(1);
const pageSize = ref<number>(100);
const searchKeyword = ref('');

const sortValue = ref<string | undefined>('companyName');
const selectedFilters = ref<{ [key: string]: string[] } | undefined>({});

const fetchData = async () => {
  loading.value = true;
  isError.value = false;
  const params: Record<string, any> = {
    pageNum: currentPage.value,
    pageSize: pageSize.value,
  }

  if (searchKeyword.value.length >= 2) {
    params.userId = searchKeyword.value;
  }

  if (sortValue.value) {
    params.sort = sortValue.value;
  }

  if (selectedFilters.value) {
    const searchFilters: Record<string, any> = {};
    Object.entries(selectedFilters.value).forEach(([key, value]) => {
      if (value.length > 0) {
        searchFilters[key] = value;
      }
    });

    if (Object.keys(searchFilters).length > 0) {
      params.search = searchFilters;
    }
  }

  try {
    const response = await getCustomerList(params);
    if (response.success) {
      totalCount.value = response.result.count;
      data.value = response.result.list;
    }
  } catch (error) {
    loading.value = false;
    isError.value = true;
    console.error('Error Message:', error);
  } finally {
    loading.value = false;
  }
}

fetchData()

const clearSearch = () => {
  searchKeyword.value = ';'
}
const handleSearch = () => {
  if(searchKeyword.value.length < 2) {
    ElMessageBox.alert('검색어는 2자 이상 입력해주세요.', {
      confirmButtonText: '확인',
    });
    return;
  }
  fetchData();
}

const router = useRouter();

const handleSizeChange = (size: number) => {
  pageSize.value = size;
  fetchData();
}
const handlePageChange = (page: number) => {
  currentPage.value = page;
  fetchData();
};

const handleSortChange = ({ prop, order }: { prop: string; order: string }) => {
  if (order === "ascending") {
    sortValue.value = prop;
  } else if (order === "descending") {
    sortValue.value = `-${prop}`
  } else {
    sortValue.value = undefined;
  }
  fetchData();
};

const handleFilterChange = (filters: Record<string, string[]>) => {
  selectedFilters.value = filters || [];
  fetchData();
};

const tableRef = ref<TableInstance>();

const handleReset = () => {
  searchKeyword.value = '';
  currentPage.value = 1;
  pageSize.value = 100;
  tableRef.value?.clearFilter();
  tableRef.value?.clearSort();
  sortValue.value = 'companyName';
  selectedFilters.value = undefined;
  fetchData(); 
}

const toCustomerView = (id: string) => {
  console.log(id)
  router.push(`/customer/view/${id}`)
}


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        modelValue: searchKeyword.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchKeyword).value = $event)),
        placeholder: "뷰저블 계정 또는 회사명을 입력하세요.",
        clearable: "",
        onClear: clearSearch,
        size: "large",
        style: {"width":"300px"},
        class: "input-search",
        onKeyup: _withKeys(handleSearch, ["enter"])
      }, {
        append: _withCtx(() => [
          _createVNode(_component_el_button, {
            "aria-label": "검색",
            onClick: handleSearch
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-magnifying-glass" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        type: "info",
        size: "large",
        class: "btn-reset",
        onClick: handleReset
      }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-rotate-left" })
        ]),
        _: 1
      })
    ]),
    (!loading.value && !isError.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_el_table, {
            data: data.value,
            "default-sort": { prop: 'id', order: 'descending' },
            style: {"width":"100%"},
            ref_key: "tableRef",
            ref: tableRef,
            onSortChange: handleSortChange,
            onFilterChange: handleFilterChange
          }, {
            empty: _withCtx(() => [
              (searchKeyword.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, " '" + _toDisplayString(searchKeyword.value) + "' 고객을 찾을 수 없습니다 ", 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, "고객 데이터가 없습니다."))
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "자세히",
                width: "60",
                align: "center",
                fixed: ""
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    "aria-label": "자세히",
                    onClick: ($event: any) => (toCustomerView(scope.row.customerId))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, { icon: "fa-regular fa-file-lines" })
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "companyName",
                label: "회사명",
                fixed: "",
                width: "220",
                sortable: "custom"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.companyName), 1),
                  _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "userId",
                label: "뷰저블 계정",
                fixed: "",
                width: "240",
                sortable: "custom"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.userId), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "managerName",
                label: "담당자",
                width: "220",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.managerName.join(', ')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "taxInfoType",
                label: `세금 계산서 발행 방식`,
                width: "200",
                align: "center",
                "column-key": "taxInfoType"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.taxInfoType)
                    ? (_openBlock(), _createBlock(StatusTag, {
                        key: 0,
                        size: "small",
                        color: _unref(getTagColor)(scope.row.taxInfoType),
                        text: _unref(getTaxInfoTypeValue)(scope.row.taxInfoType)
                      }, null, 8, ["color", "text"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" - ")
                      ], 64))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "memo",
                label: "메모"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.memo)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(scope.row.memo), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_6, "-"))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[2] || (_cache[2] = _createTextVNode(" 총 ")),
              _createElementVNode("strong", null, _toDisplayString(totalCount.value), 1),
              _cache[3] || (_cache[3] = _createTextVNode("개의 고객사 "))
            ]),
            _createVNode(_component_el_pagination, {
              "current-page": currentPage.value,
              "page-size": pageSize.value,
              "page-sizes": [30, 50, 100],
              total: totalCount.value,
              layout: "sizes, prev, pager, next",
              onSizeChange: handleSizeChange,
              onCurrentChange: handlePageChange
            }, null, 8, ["current-page", "page-size", "total"])
          ])
        ], 64))
      : (loading.value)
        ? (_openBlock(), _createBlock(CommonLoader, { key: 1 }))
        : (_openBlock(), _createBlock(CommonError, {
            key: 2,
            message: "서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.<br/> 문제가 지속되면 관리자에게 문의하세요."
          }))
  ]))
}
}

})